export const addCreditCard = (data:any) => {
    return async (dispatch: any) => {
        return dispatch({type: 'CREDIT_CARD_FORM_ADD_CHANGE', ...data})
    }
};

export const resetCreditCard = ()=>{
    return async (dispatch: any) => {
        return dispatch({type: 'RESET_CREDIT_CARD'})
    }
};
